export let ShadeSize = /*#__PURE__*/function (ShadeSize) {
  ShadeSize["Medium"] = "medium";
  ShadeSize["Small"] = "small";
  return ShadeSize;
}({});
//# sourceMappingURL=types.js.map